import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoginForm from './LoginForm.js';
import RegisterForm from './RegisterForm.js';
import ForgotPasswordForm from './ForgotPasswordForm.js';

function AuthWrapper() {
    const navigate = useNavigate();
    const location = useLocation();
    const { handleLogin, handleRegister } = useAuth();
    const [authMode, setAuthMode] = React.useState('login');

    // Determine initial auth mode based on the current path
    React.useEffect(() => {
        const mode = location.pathname === '/register' 
            ? 'register' 
            : location.pathname === '/forgot-password'
                ? 'forgot-password'
                : 'login';
        setAuthMode(mode);
    }, [location.pathname]);

    const handleLoginSubmit = async (credentials) => {
        try {
            await handleLogin(credentials);
            navigate('/');
        } catch (error) {
            console.error('Login error:', error);
            // Error is handled in the Login component
            throw error;
        }
    };

    const handleRegisterSubmit = async (userData) => {
        try {
            await handleRegister(userData);
            navigate('/');
        } catch (error) {
            console.error('Registration error:', error);
            // Error is handled in the Register component
            throw error;
        }
    };

    const handleModeChange = (mode) => {
        setAuthMode(mode);
        // Update URL to reflect current auth mode
        if (mode === 'register') {
            navigate('/register', { replace: true });
        } else if (mode === 'forgot-password') {
            navigate('/forgot-password', { replace: true });
        } else {
            navigate('/login', { replace: true });
        }
    };

    return (
        <section data-name="auth-section" className="section bg-gray-50/50 backdrop-blur-sm min-h-screen flex items-center justify-center">
            {authMode === 'login' && (
                <LoginForm 
                    onLogin={handleLoginSubmit}
                    onModeChange={handleModeChange}
                />
            )}
            {authMode === 'register' && (
                <RegisterForm 
                    onRegister={handleRegisterSubmit}
                    onModeChange={handleModeChange}
                />
            )}
            {authMode === 'forgot-password' && (
                <ForgotPasswordForm 
                    onBack={() => handleModeChange('login')}
                />
            )}
        </section>
    );
}

export default AuthWrapper;
